import api from "./api";
const svc = {
  listar:           (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/ocorrencias?${qs}`); },
  buscarPorId:      id     => api("GET",`/ocorrencias/${id}`),
  criar:            data   => api("POST","/ocorrencias",data),
  atualizar:        (id,data) => api("PUT",`/ocorrencias/${id}`,data),
  mudarStatus:      (id,data) => api("PATCH",`/ocorrencias/${id}/status`,data),
  comentar:         (id,data) => api("POST",`/ocorrencias/${id}/comentario`,data),
  gerarMulta:       (id,data) => api("POST",`/ocorrencias/${id}/gerar-multa`,data),
  vincularPagar:    (id,data) => api("PATCH",`/ocorrencias/${id}/vincular-pagar`,data),
  relatorio:        (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/ocorrencias/relatorio?${qs}`); },
  listarPrazos:     idCondominio => api("GET",`/ocorrencias/prazos?idCondominio=${idCondominio}`),
  salvarPrazo:      data   => api("POST","/ocorrencias/prazos",data),
  uploadAnexo:      (id,data) => api("POST",`/ocorrencias/${id}/anexos`,data),
  listarAnexos:     (id)      => api("GET", `/ocorrencias/${id}/anexos`),
  deletarAnexo:     (id,aid)  => api("DELETE",`/ocorrencias/anexos/${aid}`),
  downloadAnexo:    (id,aid)  => api("GET",`/ocorrencias/${id}/anexos/${aid}`),
};
export default svc;
